module.exports = __webpack_public_path__ + "static/media/user (1).2f74534f.png";